import { Action } from 'redux';
import { DeleteDataAccelerationTask, RunDataAccelerationTaskRunNow, ChangeDataAccelerationTaskSchedule } from '../../AppActionTypes';
import { IAccelerationTaskInfo } from '../../../../ts/models/IAccelerationTaskInfo';

export interface DataAccelerationTaskMenuAction extends Action {
  tasks: IAccelerationTaskInfo[];
}

export function dataAccelerationTaskRunNow(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: RunDataAccelerationTaskRunNow,
    tasks
  };
}

export function deleteDataAccelerationTask(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: DeleteDataAccelerationTask,
    tasks
  };
}

export function changeDataAccelerationTaskSchedule(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: ChangeDataAccelerationTaskSchedule,
    tasks
  };
}
